module.exports = __webpack_public_path__ + "img/news_start_ph.07d0a8d6.png";